exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods-item .mint-cell-swipe-button{width:4.5rem;font-size:.7rem;display:-webkit-box!important;display:-webkit-flex!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-sizing:border-box;box-sizing:border-box}.goods-item .mint-cell-wrapper{padding:0}.goods-item .mint-cell-wrapper .mint-cell-value{width:100%;border-bottom:1px solid #e8eaed}", ""]);

// exports
